import React, {Component} from 'react';
import {Row, Col, Breadcrumb, Spin} from 'antd';
import {Link} from 'react-router-dom';
import moment from 'moment';
import '../../css/players.css';
import {api, app, config} from "../../app";

class PlayerRescueDetail extends Component {
    constructor(props) {
        super(props);
        const train_id = props.match.params.train_id;
        this.state = {
            data_loading: true,
            trainInfo: {}
        };
        this.dataSource(train_id);
    }

    /**
     * 数据源
     */
    dataSource(train_id) {
        const _this = this, params = {
            train_id,
            indexno: app.getData('indexno'),
            account:  app.getData('account'),
            token: app.getData('token'),
        };
        app.post(api.TrainDetails2, params).then(({flag, data, msg}) => {
            if (flag === 1) {
                _this.setState({trainInfo: data});
            } else {
                app.alert("网络服务忙~", "error");
            }
            _this.setState({data_loading: false});
        });
    }

    render() {
        const province = app.getData('link_province'), teamno = app.getData('link_teamno'),
            trainInfo = this.state.trainInfo || {},
            indexno = app.getData('link_indexno'), teamno1 = null, loading = this.state.data_loading;
        return (
            <div className="ranks_content">
                <div className="r_page_title">救援列表<span>Rescue list</span></div>
                <Breadcrumb separator=">" className="r_right_breadcrumb">
                    <Breadcrumb.Item><Link to="/">首页</Link></Breadcrumb.Item>
                    {province ? (<Breadcrumb.Item><Link to={"/ranks/pro/" + province}>队伍列表</Link></Breadcrumb.Item>) : ''}
                    {teamno1 ? (
                        <Breadcrumb.Item><Link to={"/ranks/detail/" + teamno1}>查看队伍</Link></Breadcrumb.Item>) : ''}
                    {teamno ? (
                        <Breadcrumb.Item><Link to={"/ranks/Players/" + teamno}>队员列表</Link></Breadcrumb.Item>) : ''}
                    {indexno ? (
                        <Breadcrumb.Item onClick={()=>{this.props.history.go(-2)}} className="pointer">个人页面</Breadcrumb.Item>) : ''}
                    {indexno ? (
                        <Breadcrumb.Item onClick={()=>{this.props.history.go(-1)}} className="pointer">培训列表</Breadcrumb.Item>) : ''}
                    <Breadcrumb.Item>培训详情</Breadcrumb.Item>
                </Breadcrumb>
                {
                    loading ?
                        (<Row type="flex" align="middle" justify="center" className="data_loading">
                            <Spin tip="正在加载中..."></Spin>
                        </Row>)
                        : (<Row id="detail_all">
                            <h1 className="da_title">{trainInfo.trainame}</h1>
                            <Row className="da_info">
                                <Col span={12}
                                     className="dai_date">{trainInfo.startdate ? moment(trainInfo.startdate).format("YYYY-MM-DD HH:mm:ss") : "未知"}</Col>
                                <Col span={12} className="dai_ly">来源：{trainInfo.team || "未知"}</Col>
                            </Row>
                            <Row className="da_detail">
                                <Col span={24} className="dad_text">{trainInfo.detail}</Col>
                                <Col span={24} className="dad_img">{trainInfo.images ?
                                    <img src={config.imgUrl + trainInfo.images} width="80%"
                                         alt={trainInfo.trainame}/> : ''}
                                </Col>
                            </Row>
                        </Row>)
                }
            </div>
        );
    }
}

export default PlayerRescueDetail;



// WEBPACK FOOTER //
// ./src/routes/playerInfo/PlayerTrainDetail.jsx